module.exports = __webpack_public_path__ + "static/media/zaklada_logo.5c09d501.png";